import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import {AuthProvider} from "../../providers/auth/auth";
import {SERVER_URL} from "../../config";
import { ArticoliPageModule } from '../../pages/articoli/articoli.module';

/*
  Generated class for the RestApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RestApiProvider {
  private menuList = SERVER_URL+'/menu/listMenu';
  private updateListMenu = SERVER_URL+'/menu/updateList'
  private newMenu = SERVER_URL+'/menu/newMenu'
  private updateMenu = SERVER_URL+'/menu/updateMenu'

  private menuScelteliList = SERVER_URL+'/menuScelte/list';
  private newMenuscelta = SERVER_URL+'/menuScelte/newMenuScelte'
  private updateListMenuScelte = SERVER_URL+'/menuScelte/updateList'
  private updateListScelte = SERVER_URL+'/scelte/updateList'
  private scelteliList = SERVER_URL+'/scelte/list';
  private updateMenuScelte = SERVER_URL+'/menuScelte/updateMenuScelte'
  private newScelta = SERVER_URL+'/scelte/newScelta';
  private updateScelta = SERVER_URL+'/scelte/updateScelta'

  private categorieMenuList = SERVER_URL+'/categorieMenu/listS';
  private newCategoriaMenu = SERVER_URL+'/categorieMenu/newCategoriaMenu'
  private updateCategoriaMenu = SERVER_URL+'/categorieMenu/updateCategoriaMenu'
  private newUtente = SERVER_URL+'/users/newUtenteStore';

  private categorieList = SERVER_URL+'/categorie/listS';
  private articoliList = SERVER_URL+'/articoli/list';
  private newArticolo = SERVER_URL+'/articoli/newArticolo';
  private updateArticolo = SERVER_URL+'/articoli/updateArticolo';
  private newCategoria = SERVER_URL+'/categorie/newCategoria'
  private updateCategoria = SERVER_URL+'/categorie/updateCategoria'
  private updateListCategoria = SERVER_URL+'/categorie/updateList'
  private updateListCategoriaMenu = SERVER_URL+'/categorieMenu/updateList'
  private codiceTotale = SERVER_URL+'/codice/codiceTot'
  private codiceOggi = SERVER_URL+'/codice/codiceOggi'
  private sms = SERVER_URL+'/codice/codiceListToday'
  private updateListArticoli = SERVER_URL+'/articoli/updateList'
  private searchListArticoli = SERVER_URL+'/articoli/searchSuper'
  private searchListAClient = SERVER_URL+'/users/searchClientSuper'
  private searchListAClientCodice = SERVER_URL+'/users/searchClientSuperCodice'
  private searchListAClientEmail = SERVER_URL+'/users/searchClientSuperEmail'

  private ottimizzaDB = SERVER_URL+'/ordini/ottimizzaDB'

  private searchListAdmin = SERVER_URL+'/users/searchAdminSuper'
  private searchListMenus = SERVER_URL+'/menu/searchSuper'

  private infoRistorante = SERVER_URL+'/infoStore/infoClientSuper'
  private nuovoInfoRistorante = SERVER_URL+'/infoStore/newInfoStore'
  private aggiornaInfoRistorante = SERVER_URL+'/infoStore/updateInfoStore'

  private giornoConsegnaList = SERVER_URL+'/giornoConsegna/listSuper'
  private nuovoGiornoConsegna = SERVER_URL+'/giornoConsegna/newGiornoConsegna'
  private updateGiornoConsegna = SERVER_URL+'/giornoConsegna/updateGiornoConsegna'
  private storeToday = SERVER_URL + '/giornoConsegna/storeTodaySuper';


  private nuovoCapConsegna = SERVER_URL+'/capConsegna/newCapConsegna'
  private capConsegnaList = SERVER_URL+'/capConsegna/list'
  private ordineTodayList = SERVER_URL+'/ordini/ordineListTodaySuper'
  private ordineDayList = SERVER_URL+'/ordini/ordineListDaySuper'
  private ordineWeekList = SERVER_URL+'/ordini/ordineListWeekSuper'
  private ordineMonthList = SERVER_URL+'/ordini/ordineListMonthSuper'
  private updateListManifesto = SERVER_URL+'/manifesti/updateList'
  private ordineMonthCount = SERVER_URL+'/ordini/ordineListMonthCount'


  private selStore = SERVER_URL + '/users/selStore';
  private updateUser = SERVER_URL + '/users/updateUser';
  private resetUser = SERVER_URL + '/users/restPasswordUser';
  private addressConsegna = SERVER_URL + '/address/addressConsegnaSuper';
  private ordineLastTen = SERVER_URL + '/ordini/ordineLastTenSuper';

  
  private manifestiList = SERVER_URL + '/manifesti/manifestiListAll';

  private ordineItemList = SERVER_URL+'/ordineItem/ordineItemList'

  private capList = SERVER_URL+'/capConsegna/capListS'
  private updateCapConsegna = SERVER_URL+'/capConsegna/updateCapConsegna'
  private deleteCapConsegna = SERVER_URL+'/capConsegna/deleteCapConsegna'

  private usersListClient = SERVER_URL+'/users/listClient'
  private numeroUtenti = SERVER_URL+'/users/numeroUtenti'

  private usersList = SERVER_URL+'/users/listA'
  private aperturaUpdate = SERVER_URL+'/infoStore/updateApertura'

  private user = SERVER_URL+'/users/selUser'
  private updateManifest = SERVER_URL+'/manifesti/updateManifesto'
  private getValuta = SERVER_URL + '/valutazione/getValutazione';
  private ordineMenuList = SERVER_URL+'/ordineMenu/ordineMenuList'
  private valutazioneList = SERVER_URL+'/valutazione/valutazioneListSuper';
  private updateValutazione = SERVER_URL+'/valutazione/updateValutazione'
  private orariConsegna = SERVER_URL+'/giornoConsegna/orariConsegna'
  private updateOrdine = SERVER_URL + '/ordini/updateOrdineAdmin';
  private notifica = SERVER_URL+'/users/notificaSuper'
  private newCoupon = SERVER_URL+'/coupon/newCoupon'
  private updateCoupon = SERVER_URL+'/coupon/updateCoupon'
  private couponList = SERVER_URL+'/coupon/listCoupon';
  private couponRicerca = SERVER_URL+'/coupon/searchSuper';
  private storeTimeListInfo = SERVER_URL + '/giornoConsegna/listInfo';

  aut;
  constructor(public http: HttpClient,authProvider: AuthProvider) {
    this.aut=authProvider;

    console.log('Hello RestApiProvider Provider');
  }
  getTimeStoreInfo(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getTimeStore rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.storeTimeListInfo, { headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }
  searchCoupons( name): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro searchCoupons rest')
    console.log('searchCoupons :'+name);

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.couponRicerca,name,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getCoupons(): Observable<string[]> {
    console.log('dentro getCoupons rest')

    let headers = this.aut.getHttpHeaders();
    console.log('dentro getCoupons headers:'+JSON.stringify(headers));

    return this.http.post(this.couponList,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  nuovaCoupon( coupon): Observable<any> {
    console.log('dentro nuovaCoupon rest')
    console.log('nuovaCoupon json:'+JSON.stringify(coupon));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newCoupon,JSON.stringify(coupon),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }  
  aggiornaCoupon( coupon): Observable<any> {
    console.log('dentro aggiornaCoupon rest')
    console.log('aggiornaCoupon json:'+JSON.stringify(coupon));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateCoupon,JSON.stringify(coupon),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }  
  getValutazioni(): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro getValutazioni rest')

    let headers = this.aut.getHttpHeaders();
    console.log('dentro getValutazioni headers:'+JSON.stringify(headers));

    return this.http.post(this.valutazioneList,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  } 
  updateManifesto(manifesto){
    this.aut.checkLogin();
    console.log('dentro updateManifesto rest')
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateManifest,JSON.stringify(manifesto),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }
  aggiornaListManifesto( manifesti) {
    this.aut.checkLogin();

    console.log('dentro aggiornaListManifesto rest')
    console.log('categorieList json:'+JSON.stringify(manifesti));
    for (var _i = 0; _i < manifesti.length; _i++) {

      console.log("manifesto rest----------------------------------:" + manifesti[_i]["name"]+ " "+manifesti[_i]["priority"]);

    }
    
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateListManifesto,JSON.stringify(manifesti),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  getManifesti(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getManifesti rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.manifestiList, { headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }
  getSelStore(storeId) {
    this.aut.checkLogin();

    console.log('dentro getSelStore rest')
    console.log('getCodice :' + storeId);

    let headers = this.aut.getHttpHeaders();
    this.http.post(this.selStore, storeId, { headers: headers }).subscribe(res => {
      console.log("success " + res);
    }, (err) => {
      console.log("errore: " + err.json);
    });

  }

  getAddressConsegna(user): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getAddressConsegna rest:'+user.id)

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.addressConsegna,JSON.stringify(user.id),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  } 
  getOrdineLastTen(user): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrdineLastTen rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ordineLastTen,JSON.stringify(user.id), { headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }
  aggiornaUser(user) {
    this.aut.checkLogin();

    console.log('dentro aggiornaUser rest')

    let headers = this.aut.getHttpHeaders();
    this.http.post(this.updateUser, JSON.stringify(user), { headers: headers }).subscribe(res => {
      console.log("success " + res);
    }, (err) => {
      console.log("errore: " + err.json);
    });

  }
  restPasswordUser(user) {
    this.aut.checkLogin();

    console.log('dentro restPasswordUser rest')

    let headers = this.aut.getHttpHeaders();
    this.http.post(this.resetUser, JSON.stringify(user), { headers: headers }).subscribe(res => {
      console.log("success " + res);
    }, (err) => {
      console.log("errore: " + err.json);
    });

  }
  getUsersList(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getUsersList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.usersList,{headers}).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getUser(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getUser rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.user,{headers}).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getUsersListClient(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getUsersList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.usersListClient,{headers}).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getNumeroUtenti(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getNumeroUtenti rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.numeroUtenti,{headers}).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  invioUpdateOrdine(ordine) {
    this.aut.checkLogin();
   // alert("ordine:"+JSON.stringify(ordine));
    console.log('dentro invioUpdateOrdine rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateOrdine, JSON.stringify(ordine), { headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });
  }
  notificaSuper(utente) {
    this.aut.checkLogin();
   // alert("ordine:"+JSON.stringify(ordine));
    console.log('dentro notificaSuper rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.notifica, JSON.stringify(utente), { headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });
  }
  getOrarioList(ordineId): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrarioList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.orariConsegna,JSON.stringify(ordineId),{headers}).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getOrdineMenu(ordineId): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrdineMenu rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ordineMenuList,JSON.stringify(ordineId),{headers}).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getOrdineItemList(ordineId): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrdineItemList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ordineItemList,JSON.stringify(ordineId),{headers}).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getOrdineTodayList(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrdineTodayList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ordineTodayList,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  aggiornaValutazione( valutazione) {
    this.aut.checkLogin();

    console.log('dentro aggiornaValutazione rest')
    console.log('categoria json:'+JSON.stringify(valutazione));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateValutazione,JSON.stringify(valutazione),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  getOrdineDayList(day): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrdineDayList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ordineDayList,JSON.stringify(day),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getOrdineWeekList(day): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrdineWeekList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ordineWeekList,JSON.stringify(day),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getOrdineMonthList(day): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrdineMonthList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ordineMonthList,JSON.stringify(day),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getOrdineMonthCount(day): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getOrdineMonthCount rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ordineMonthCount,JSON.stringify(day),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getCaps(): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro getCaps rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.capList,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getCapConsegnaList( capList) {
    this.aut.checkLogin();

    console.log('dentro getCapConsegnaList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.capConsegnaList,JSON.stringify(capList),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  addCapConsegna( capConsegna) {
    this.aut.checkLogin();

    console.log('dentro newCapConsegna rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.nuovoCapConsegna,JSON.stringify(capConsegna),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaCapConsegna( capConsegna) {
    this.aut.checkLogin();

    console.log('dentro aggiornaCapConsegna rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateCapConsegna,JSON.stringify(capConsegna),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  removeCapConsegna( capConsegna) {
    this.aut.checkLogin();

    console.log('dentro removeCapConsegna rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.deleteCapConsegna,JSON.stringify(capConsegna),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  newGiornoConsegna( giornoConsegna) {
    this.aut.checkLogin();

    console.log('dentro newGiornoConsegna rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.nuovoGiornoConsegna,JSON.stringify(giornoConsegna),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaGiornoConsegna( giornoConsegna): Observable<any>{
    this.aut.checkLogin();

    console.log('dentro aggiornaGiornoConsegna rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateGiornoConsegna,JSON.stringify(giornoConsegna),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getGiornoConsegnaList(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getGiornoConsegnaList rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.giornoConsegnaList,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  infoStoreToday(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro infoStoreToday rest')

    let headers = this.aut.getHttpHeaders();
    let esito;

    return this.http.post(this.storeToday, { headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }
  updateApertura(infoStore){
    this.aut.checkLogin();
    console.log('dentro updateApertura rest')
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.aperturaUpdate,infoStore,{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        alert("errore:"+JSON.stringify(err));
        alert("errore:"+err);

        console.log("errore: "+err.json);
      });

  }
  getValutazione(ordineId): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getValutazione rest')

    let headers = this.aut.getHttpHeaders();
    let esito;
    return this.http.post(this.getValuta, JSON.stringify(ordineId), { headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }
  getInfoRistorante(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getInfoRistorante rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.infoRistorante,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  updateInfoRistorante( infoStore) {
    this.aut.checkLogin();

    console.log('dentro updateInfoRistorante rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.aggiornaInfoRistorante,JSON.stringify(infoStore),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaScelta( scelta) {
    this.aut.checkLogin();

    console.log('dentro aggiornaScelta rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateScelta,JSON.stringify(scelta),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  newInfoRistorante( infoStore) {
    this.aut.checkLogin();

    console.log('dentro newInfoRistorante rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.nuovoInfoRistorante,JSON.stringify(infoStore),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  getMenus(categoriaMenu): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro getMenus rest')

    let headers = this.aut.getHttpHeaders();
    console.log('dentro getMenus headers:'+JSON.stringify(headers));

    return this.http.post(this.menuList,JSON.stringify(categoriaMenu),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getCategorie(): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro getCategorie rest')

    let headers = this.aut.getHttpHeaders();
    console.log('dentro getCategorie headers:'+JSON.stringify(headers));

    return this.http.post(this.categorieList,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getCategorieMenu(): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro getCategorieMenu rest')

    let headers = this.aut.getHttpHeaders();
    console.log('dentro getCategorieMenu headers:'+JSON.stringify(headers));

    return this.http.post(this.categorieMenuList,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getArticoli( categoria): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro getArticoli rest')
    console.log('categoria json:'+JSON.stringify(categoria));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.articoliList,JSON.stringify(categoria),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getMenuScelte( menu): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro getMenuScelte rest')
    console.log('menu json:'+JSON.stringify(menu));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.menuScelteliList,JSON.stringify(menu),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  } 
  getScelte( menuScelte): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro getScelte rest')
    console.log('menu json:'+JSON.stringify(menuScelte));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.scelteliList,JSON.stringify(menuScelte),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }   
  searcArticoli( name): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro searcArticoli rest')
    console.log('searcArticoli :'+name);

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.searchListArticoli,name,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  searcMenus( name): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro searcMenus rest')
    console.log('searcMenus :'+name);

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.searchListMenus,name,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  searcUserClient( name): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro searcUserClient rest')
    console.log('searcUserClient :'+name);

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.searchListAClient,name,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  ottimizzazione(): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro ottimizzazione rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.ottimizzaDB,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  searcUserClientCodice( name): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro searcUserClientCodice rest')
    console.log('searcUserClientCodice :'+name);

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.searchListAClientCodice,name,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  searcUserClientEmail( name): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro searcUserClientEmail rest')
    console.log('searcUserClientEmail :'+name);

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.searchListAClientEmail,name,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  searcUserAdmin( name): Observable<string[]> {
    this.aut.checkLogin();

    console.log('dentro searcUserAdmin rest')
    console.log('searcUserAdmin :'+name);

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.searchListAdmin,name,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  } 
  login( name): Observable<string> {
    this.aut.checkLogin();

    console.log('dentro login rest')
    console.log('login :'+name);

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.searchListArticoli,name,{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  nuovaCategoria( categoria):Observable<string> {
    this.aut.checkLogin();

    console.log('dentro nuovaCategoria rest')
    console.log('categoria json:'+JSON.stringify(categoria));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newCategoria,JSON.stringify(categoria),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }  
  getCodiceTot(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getCodiceTot rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.codiceTotale,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }  
  getCodiceOggi(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro getCodiceOggi rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.codiceOggi,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  } 
  getSms(): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro sms rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.sms,headers).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  } 
  nuovaCategoriaMenu( categoriaMenu): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro nuovaCategoriaMenu rest')
    console.log('categoria json:'+JSON.stringify(categoriaMenu));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newCategoriaMenu,JSON.stringify(categoriaMenu),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }  
  nuovaMenuScelta( menuscelta) {
    this.aut.checkLogin();

    console.log('dentro nuovaMenuScelta rest')
    console.log('categoria json:'+JSON.stringify(menuscelta));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newMenuscelta,JSON.stringify(menuscelta),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  nuovaMenu( menu): Observable<any>  {
    this.aut.checkLogin();

    console.log('dentro nuovaMenu rest')
    console.log('menu json:'+JSON.stringify(menu));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newMenu,JSON.stringify(menu),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }  
  aggiornaMenu( menu) : Observable<any> {
    this.aut.checkLogin();

    console.log('dentro aggiornaMenu rest')

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateMenu,JSON.stringify(menu),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }  
  nuovoUtenteStore( utente): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro nuovoUtenteStore rest')
    console.log('nuovoUtenteStore json:'+JSON.stringify(utente));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newUtente,JSON.stringify(utente),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }  
  nuovoArticolo( articolo): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro newArticolo rest')
    console.log('articolo json:'+JSON.stringify(articolo));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newArticolo,JSON.stringify(articolo),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );


  }  
  /*
  nuovoArticolo( articolo) {
    this.aut.checkLogin();

    console.log('dentro newArticolo rest')
    console.log('articolo json:'+JSON.stringify(articolo));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newArticolo,JSON.stringify(articolo),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  */
  nuovoScelta( scelta) {
    this.aut.checkLogin();

    console.log('dentro nuovoScelta rest')
    console.log('scelta json:'+JSON.stringify(scelta));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.newScelta,JSON.stringify(scelta),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaArticolo( articolo): Observable<any>  {
    this.aut.checkLogin();

    console.log('dentro aggiornaArticolo rest')
    console.log('articolo json:'+JSON.stringify(articolo));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateArticolo,JSON.stringify(articolo),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );

  }  
  aggiornaCategoria( categoria): Observable<any>  {
    this.aut.checkLogin();

    console.log('dentro aggiornaCategoria rest')
    console.log('categoria json:'+JSON.stringify(categoria));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateCategoria,JSON.stringify(categoria),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );


  }  
  aggiornaCategoriaMenu( categoriaMenu): Observable<any> {
    this.aut.checkLogin();

    console.log('dentro aggiornaCategoria rest')
    console.log('categoria json:'+JSON.stringify(categoriaMenu));

    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateCategoriaMenu,JSON.stringify(categoriaMenu),{ headers: headers }).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );


  }  
  aggiornaListCategoria( categorie) {
    this.aut.checkLogin();

    console.log('dentro aggiornaListCategoria rest')
    console.log('categorieList json:'+JSON.stringify(categorie));
    for (var _i = 0; _i < categorie.length; _i++) {

      console.log("categoria rest----------------------------------:" + categorie[_i]["name"]+ " "+categorie[_i]["visilibita"]);

    }
    
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateListCategoria,JSON.stringify(categorie),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaListCategoriaMenu( categorieMenu) {
    this.aut.checkLogin();

    console.log('dentro aggiornaListCategoria rest')
    console.log('categorieList json:'+JSON.stringify(categorieMenu));
    for (var _i = 0; _i < categorieMenu.length; _i++) {

      console.log("categoria rest----------------------------------:" + categorieMenu[_i]["name"]+ " "+categorieMenu[_i]["visilibita"]);

    }
    
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateListCategoriaMenu,JSON.stringify(categorieMenu),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaListMenu( menus) {
    this.aut.checkLogin();

    console.log('dentro aggiornaListMenu rest')
    console.log('menuList json:'+JSON.stringify(menus));
    for (var _i = 0; _i < menus.length; _i++) {

      console.log("categoria rest----------------------------------:" + menus[_i]["nome"]+ " "+menus[_i]["visilibita"]);

    }
    
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateListMenu,JSON.stringify(menus),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaListMenuScelte( menuScelte) {
    this.aut.checkLogin();

    console.log('dentro aggiornaListMenuScelte rest')
    console.log('menuList json:'+JSON.stringify(menuScelte));
    for (var _i = 0; _i < menuScelte.length; _i++) {

      console.log("categoria rest----------------------------------:" + menuScelte[_i]["nome"]+ " "+menuScelte[_i]["visilibita"]);

    }
    
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateListMenuScelte,JSON.stringify(menuScelte),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaMenuScelte( menuScelte) {
    this.aut.checkLogin();

    console.log('dentro aggiornaMenuScelte rest')
    console.log('menuScelte json:'+JSON.stringify(menuScelte));
   
    
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateMenuScelte,JSON.stringify(menuScelte),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaListScelte( scelte) {
    this.aut.checkLogin();

    console.log('dentro aggiornaListArticoli rest')
    console.log('articoli json:'+JSON.stringify(scelte));
    for (var _i = 0; _i < scelte.length; _i++) {

      console.log("articoli rest----------------------------------:" + scelte[_i]["nome"]+ " "+scelte[_i]["visilibita"]);



    }
    
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateListScelte,JSON.stringify(scelte),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
  aggiornaListArticoli( articoli) {
    this.aut.checkLogin();

    console.log('dentro aggiornaListArticoli rest')
    console.log('articoli json:'+JSON.stringify(articoli));
    for (var _i = 0; _i < articoli.length; _i++) {

      console.log("articoli rest----------------------------------:" + articoli[_i]["name"]+ " "+articoli[_i]["visilibita"]);



    }
    
    let headers = this.aut.getHttpHeaders();

    return this.http.post(this.updateListArticoli,JSON.stringify(articoli),{ headers: headers }).subscribe(res => {
      console.log("success "+res);
      }, (err) => {
        console.log("errore: "+err.json);
      });

  }  
private extractData(res: Response) {
  console.log('data rest:'+JSON.stringify(res));
  let body = res;
  return body || {};
}

private handleError (error: Response | any) {
  let errMsg: string;
  if (error instanceof Response) {
    const err = error || '';
    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  } else {
    errMsg = error.message ? error.message : error.toString();
  }
  console.error(errMsg);
  return Observable.throw(errMsg);
}
}



// WEBPACK FOOTER //
// ./src/providers/rest-api/rest-api.ts